<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const totalImages = 14
const intervalId = ref(null)

// Vybere náhodné číslo 1-14, ale ne previousImage
const getRandomImageNumber = (previousImage = null) => {
  let newImage
  do {
    newImage = Math.floor(Math.random() * totalImages) + 1
  } while (newImage === previousImage)
  return newImage
}

// Inicializuj currentImage hned při vytvoření komponenty
const currentImage = ref(getRandomImageNumber())

const changeImage = () => {
  currentImage.value = getRandomImageNumber(currentImage.value)
}

onMounted(() => {
  intervalId.value = setInterval(changeImage, 12000)
})

onUnmounted(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value)
  }
})
</script>

<template>
  <div class="random-image-container">
    <transition name="fade" mode="out-in">
      <img
        :key="currentImage"
        :src="`img/home/${currentImage}.png`"
        :alt="`Image ${currentImage}`"
        class="random-image"
      />
    </transition>
  </div>
</template>

<style scoped>
.random-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -1rem;
  margin-bottom: 1rem;
}

.random-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
